import React, { Component } from 'react'
import { Card, ListGroup } from 'react-bootstrap'
import { connect } from 'react-redux'
import * as actions from '../../actions'
import { IconButton } from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import ConsultaChoferInfo from './ConsultaChoferInfo'
import Alert from '@material-ui/lab/Alert'

class ConsultaSinIngreso extends Component {
  componentDidMount () {
    const { getTotalCamiones } = this.props
    getTotalCamiones()
  }

  render () {
    const {
      cpa,
      handleReset,
      fechaCupo,
      totalCamiones
    } = this.props

    const numero = cpa.numero
    const camion = cpa.camion
    const acoplado = cpa.acoplado
    const cereal = cpa.cereal
    const cpeSucursal = cpa.cpeSucursal

    const cpaDatos = {
      numero,
      camion,
      acoplado,
      cereal,
      fechaCupo,
      cpeSucursal
    }

    var camionesEnPlaya
    if (cpa.numero && totalCamiones) {
      const camionesCereal = totalCamiones.filter(camiones => camiones.cereal.trim() === cpa.cereal.trim())
      if (camionesCereal[0]) {
        console.log(camionesCereal)
        camionesEnPlaya = camionesCereal[0].enPlaya
      } else {
        camionesEnPlaya = 0
      }
    }

    let normalizarCupo

    return (
      <div>
        <div className='titulo-en-cabecera'>
          <IconButton onClick={handleReset}><ArrowBackIcon /></IconButton>
          <h5>Estado de carta de porte</h5>
        </div>

        { !cpa.numero && <Alert className='alert-consulta-chofer' style={{ margin: '5% 2%' }} variant='filled' severity='error'>
          <strong style={{ fontSize: '1.05rem' }}>¡Carta de Porte inexistente!</strong>
        </Alert> }

        { cpa && cpa.numero && <div>
          <ConsultaChoferInfo cpaDatos={cpaDatos} />

          { normalizarCupo && <div style={{ margin: '0 2%' }}>
            <Alert className='alert-consulta-chofer' variant='filled' severity='warning'>
              <strong style={{ fontSize: '1.05rem' }}>Deberá normalizar su cupo</strong>
            </Alert>
          </div>
          }
          <div style={{ margin: '0 2%' }}>
            <Alert className='alert-consulta-chofer' variant='filled' severity='warning'>
              <strong style={{ fontSize: '1.05rem' }} >Sr. transportista por favor verifique sus datos para evitar demoras.</strong>
            </Alert>
          </div>
          <Card className='card-info-sin-ingreso'>
            <Card.Header style={{ backgroundColor: '#3f51b5', color: 'white' }}>
              <Card.Title style={{ margin: 'auto' }}>A la espera para realizar ingreso</Card.Title>
            </Card.Header>
            {cpa && cpa.razonSocialVendedor && <Card.Body>
              <ListGroup.Item style={{ border: 'none', fontSize: '1.1rem' }}>Entregador: <strong>{cpa && cpa.razonSocialVendedor}</strong></ListGroup.Item>
            </Card.Body> }
            {camionesEnPlaya && <Card style={{ margin: '2%' }}>
              <Card.Body>
                <div className='cantidad-camiones-playa'>
                  { (camionesEnPlaya === 1) && <h6 style={{ padding: '15px' }} className='texto-info'>Hay <strong>{camionesEnPlaya}</strong> camión de {cpa.nombreCereal} en la playa municipal.</h6> }
                  { (camionesEnPlaya > 1) && <h6 style={{ padding: '15px' }} className='texto-info'>Hay <strong> {camionesEnPlaya} </strong> camiones de {cpa.nombreCereal} en la playa municipal.</h6> }
                </div>
              </Card.Body>
            </Card>}
          </Card>
          <div style={{ margin: '10% 0' }} ><strong>¡Que tenga un buen dia!</strong></div>
        </div>
        }
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  totalCamiones: state.camionesIngreso.totalCamionesCereal
})

const withRedux = connect(mapStateToProps, actions)

export default withRedux(ConsultaSinIngreso)
